import React, { useEffect, useState } from 'react';

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      type='button'
      aria-label='Scroll to top'
      className={`hydro-scrolltop d-print-none ${visible ? 'show' : ''}`}
      tabIndex={visible ? 0 : -1}
      aria-hidden={visible ? undefined : 'true'}
      onClick={() =>
        window.scrollTo({
          top: 0,
          behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)')
            .matches
            ? 'auto'
            : 'smooth',
        })
      }
    >
      <i className='ri-arrow-up-line' aria-hidden='true'></i>
    </button>
  );
};

export default ScrollToTopButton;
